import { DefaultRequest } from 'scripts/api';

class DataImportRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "DataImport";

    super(entityName);

    App.Objects = App.Objects || {};
    App.Objects.DataImport = this;
    Monet.Session.DataImport = {};
    Monet.Session.DataImport.urlCSVProgress =
      Monet.Session.DataImport.urlCSVProgress || "Import/CSV/Job/";
  }

  show = () => {
    Monet.TabControl.closeActions.DataImport = function() {
      delete App.Forms.DataImport;
    };
    this.makeForm();
  };

  makeForm = () => {
    var dataImportTabContainer = document.getElementById("DataImport");
    const help = new Monet.UI.Help(
      "DataImport",
      Monet.I18n.getResourcesByKey("Greenmile.DataImport.screenName")
    );
    this.view = new Greenmile.DataImport.View();

    dataImportTabContainer.innerHTML = "";
    dataImportTabContainer.appendChild(help.render());
    dataImportTabContainer.appendChild(this.view.render());
  };

  setStatusClassToProgress = (data, progress) => {
    switch (data.status) {
      case "STARTED":
      case "PROCESSING":
      case "SUCCESS":
        progress.className =
          "dataImporterStatusProgress dataImporterStatusSuccess";
        break;
      case "PENDING":
        progress.className =
          "dataImporterStatusProgress dataImporterStatusPending";
        break;
      case "FAILURE":
        progress.className =
          "dataImporterStatusProgress dataImporterStatusFailure";
        break;
      default:
        console.log(
          "In setStatusClassToProgress not have an default status, file: DataImport"
        );
        break;
    }
  };

  writeLogToModal = data => {
    var modalContainer = document.querySelector(
      "#DataImport .popupFormContainer"
    );
    var logListContainer = document.createElement("div");
    var fragment = document.createDocumentFragment();
    var messages = null;

    logListContainer.className = "DataImportLogListContainer";

    if (data.erroMessages) {
      messages = data.erroMessages;

      for (var i = 0, l = messages.length; i < l; i++) {
        var item = document.createElement("div");
        item.innerHTML = messages[i].message;

        fragment.appendChild(item);
      }

      logListContainer.appendChild(fragment);
      modalContainer.appendChild(logListContainer);
    }
  };

  getImportStatus = (token, obj) => {
    var request = new Monet.Ajax();
    var objProgress = obj ? obj : null;
    request.url = Monet.Session.DataImport.urlCSVProgress + token;
    request.success = (function(scope) {
      return function(data) {
        scope.showImportStatus(data, objProgress);
      };
    })(this);

    request.send();
  };

  showImportStatus = (data, objProgress) => {
    if (objProgress === null) {
      if (data.status === "FAILURE") {
        var selector = "#DataImport";
        var scopeBlock = "#DataImport";
        var options = {
          width: 900,
          height: 530
        };
        var callbacks = {
          onAfterShowModalForm: (function(data, scope) {
            return function() {
              scope.writeLogToModal(data);
            };
          })(data, this)
        };

        this.modalForm = new Monet.Form.Modal(
          selector,
          options,
          callbacks,
          scopeBlock
        );

        this.modalForm.showModalForm();
      }

      clearInterval(Monet.Session.DataImport.updater);
      delete Monet.Session.DataImport.updater;
    } else {
      objProgress.field.style.backgroundSize = data.progress + "% 50px";
      objProgress.field.innerHTML = data.progress + "% ";

      if (data.progress === 100) {
        objProgress.status.innerHTML = Monet.I18n.getResourcesByKey(
          "DataImport.JobsLists." + data.status
        );

        this.setStatusClassToProgress(data, objProgress.field);

        clearInterval(objProgress.timer);
      }
    }
  };

  processUploadedFile = (uploadFile, layoutId, typeImport = "PATCH") => {
    this.view.uploadFile.btnProcess.disable();
    var request = new Monet.Ajax();

    request.url = `/Process?typeImport=${typeImport}`;
    request.method = "POST";
    request.data = {
      fileId: uploadFile.id,
      layoutId: layoutId
    };
    request.success = function(data) {
      this.view.uploadFile.btnProcess.enable();

      if (data) {
        this.view.processingStatus.updateNow();
        delete App.Forms.DataImport.uploadFile;
        document.querySelector("#DataImport .inputfile").value = "";

        this.view.clearUploadStatus();
      } else {
        console.log("[DataImport] Error on import file");
      }
    }.bind(this);

    request.error = function() {
      this.view.uploadFile.btnProcess.enable();

      console.log("[DataImport] Error on import file");
    }.bind(this);

    request.send();
  };
}

App.Routers.DataImport = DataImportRouter;
